import React from "react";

const CheckboxFilledIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 0H14C16.2 0 18 1.8 18 4V14C18 16.2 16.2 18 14 18H4C1.8 18 0 16.2 0 14V4C0 1.8 1.8 0 4 0ZM7.8 13.2L14.7 6.2C15.1 5.8 15.1 5.2 14.7 4.8C14.3 4.4 13.7 4.4 13.3 4.8L7.1 11.1L4.7 8.6C4.3 8.2 3.7 8.2 3.3 8.6C2.9 9 2.9 9.6 3.3 10L6.4 13.2C6.6 13.4 6.8 13.5 7.1 13.5C7.4 13.5 7.6 13.4 7.8 13.2Z"
                fill="#00A9A4"
            />
        </svg>
    );
};

export default CheckboxFilledIcon;
